import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/costTransactions',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/costTransactions/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/costTransactions',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/costTransactions/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/costTransactions/${id}`,
      method: 'delete',
    })
  }

  export function chart(params) {
    return request({
        url: '/costTransactions/costTransactions/chart',
        method: 'get',
        params
    })
  }